import React from 'react';
import { Shield, MessageSquare, Mail } from 'lucide-react';
export function PrivacyStatement() {
  return <div className="min-h-screen bg-white pt-40 lg:pt-52 pb-20" data-id="element-1486" data-mp="u6j9a7cqvbv">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1487" data-mp="3i21owr6ay0nw">
        {/* Page Header */}
        <div className="mb-12" data-id="element-1488" data-mp="3i4effsq4ljck">
          <div className="flex items-center justify-center mb-4" data-id="element-1489" data-mp="3n0bjp0o46z8z">
            <Shield className="w-12 h-12 text-brand-purple-600 mr-4" data-id="element-1490" data-mp="3n2xztop2mn2t" />
            <h1 className="text-4xl font-bold text-gray-900" data-id="element-1491" data-mp="em39f8pgmv5m">
              Privacy Statement
            </h1>
          </div>
        </div>

        {/* General Privacy Statement */}
        <div className="prose prose-lg max-w-none mb-12" data-id="element-1492" data-mp="4uqj4ljb8d1p">
          <p className="text-base leading-relaxed text-gray-700" data-id="element-1493" data-mp="9ubigx2e6ney">
            By registering with Desert Sage Seminars, you will create an account
            by which we may provide you with quality On-Demand real estate
            license renewal classes. Your information will be kept confidential
            and not shared with any other party. The Arizona Department of Real
            Estate requires that we confirm your information and that you are
            the person taking the classes. We will ask you to affirm that each
            time you begin a class. Impersonating a real estate licensee is
            subject to forfeiture of the real estate license for either or both
            parties. Payments you make for our classes are made through a 3rd
            party merchant account secured by our site, and they do not share
            your credit card information with us or any other party.
          </p>

          <p className="text-base leading-relaxed text-gray-700 mt-6" data-id="element-1494" data-mp="devqmeoexers">
            All payment information collected is done so under SSL – a standard
            internet security measure. Any data that we store about you is kept
            behind a secure firewall in our database and is not accessible to
            the public in any way. Any requests by an outside party for
            informaton about you or your account will be denied except for any
            request from the Arizona Department of Real Estate, or any other
            regulatory agency empowered to investigate your real estate
            activity.
          </p>
        </div>

        {/* Terms Section */}
        <div id="terms" className="border-t-2 border-gray-200 pt-12 mb-12" data-id="element-1495" data-mp="3dxf3iz4govmt">
          <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-1496" data-mp="3ivqghiq1zm99">
            Terms of Service
          </h2>

          <div className="space-y-6" data-id="element-1497" data-mp="3mwk40azl2z1m">
            <p className="text-base leading-relaxed text-gray-700" data-id="element-1498" data-mp="3mvilxmk5hcae">
              Under no circumstances will Desert Sage Seminars sell or share
              your name, mobile telephone number, or other personal information
              with third-parties or affiliates for marketing or promotional
              purposes.
            </p>

            <p className="text-base leading-relaxed text-gray-700" data-id="element-1499" data-mp="aff2y518jsj8">
              Under no circumstances will Desert Sage Seminars purchase or use
              your name and mobile telephone number collected from third
              parties.
            </p>
          </div>
        </div>
      </div>
    </div>;
}